<template>
  <div class="container">
    <md-progress-bar md-mode="query" class="md-accent" v-if="loadingAdvertising"></md-progress-bar>
    <div class="md-layout" v-else>
      <div class="md-layout-item md-size-100">
        <span class="md-title">{{$t('advertising.list.title')}}</span>
        <md-toolbar class="md-toolbar-section-end md-transparent" md-elevation="0">
          <md-field class="md-layout-item md-size-25">
            <label>{{$t('advertising.list.filter')}}</label>
            <md-select v-model="gameSelect" name="team" id="team">
              <md-option v-for="game in nextGames" :value="game.id" :key="game.id">
                {{getGameString(game.id)}}
              </md-option>
            </md-select>
          </md-field>
        </md-toolbar>
      </div>

      <div class="md-layout-item md-size-100 mt-24">
        <md-table v-if="listAdvertising.length > 0">
          <md-table-row>
            <md-table-head>{{$t('advertising.list.game')}}</md-table-head>
            <md-table-head>{{$t('advertising.list.team')}}</md-table-head>
            <md-table-head>{{$t('advertising.list.sizeVideos')}}</md-table-head>
            <md-table-head>{{$t('advertising.list.actions')}}</md-table-head>
          </md-table-row>

          <md-table-row v-for="advertising in listAdvertising" :key="advertising.id">
            <md-table-cell>{{getGameString(advertising.gameId)}}</md-table-cell>
            <md-table-cell>{{advertising.teamId != null ? getTeamString(advertising.gameId, advertising.teamId) : '-'}}</md-table-cell>
            <md-table-cell>{{advertising.items.length}} Videos</md-table-cell>
            <md-table-cell>
              <md-button class="md-info" :to="`/advertising/${advertising.id}`">
                {{$t('advertising.list.detail')}}
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
        <md-empty-state
          v-if="nextGames.length == 0"
          md-icon="campaign"
          md-label="Sin partidos proximos">
        </md-empty-state>
        <md-empty-state
          v-if="listAdvertising.length == 0"
          md-icon="campaign"
          md-label="Sin publicidades"
          md-description="No hay publicidades cargadas para el partido seleccionado">
        </md-empty-state>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  data () {
    return {
      loadingAdvertising: true,
      gameSelect: 0
    }
  },
  computed: {
    ...mapState({
      nextGames: state => state.GameModule.nextGames,
      listAdvertising: state => state.AdvertisingModule.listAdvertising
    })
  },
  async mounted() {
    await this.$store.dispatch("gameGetNext")
    if (this.nextGames.length > 0) {
      this.gameSelect = this.nextGames[0].id
      await this.$store.dispatch('getAdvertisingForGame', {gameId : this.gameSelect})
    }
    this.loadingAdvertising = false
  },
  methods: {
    getDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm")
    },
    getGameString(gameId) {
      const game = this.nextGames.find(game => game.id == gameId)
      return `${game.local.name} vs ${game.visitor.name} | ${this.getDate(game.scheduledMatchDate)} - ${game.season.name} Fecha : ${game.matchday}`
    },
    getTeamString(gameId, teamId) {
      const game = this.nextGames.find(game => game.id == gameId)
      return game.local.id === teamId ? game.local.name : game.visitor.name
    }
  },
  watch: {
    async gameSelect() {
      this.loadingAdvertising = true
      await this.$store.dispatch('getAdvertisingForGame', {gameId : this.gameSelect})
      this.loadingAdvertising = false
    }
  }
}
</script>

<style lang="scss">
  .mt-24 {
    margin-top: 24px;
  }
</style>